module.exports = __webpack_public_path__ + "img/icon_charger_monitor.11aa9a6d.png";